import { useState } from 'react';
import { AddIcon } from '@trading-ui/icons';
import { TradingButton, TradingText } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { PricingIndex } from '@/api/services/settings/pricing-indices.service';

import { PricingIndicesTable, getPricingIndicesColumns } from '../../tables/pricing-indices-table';
import { CreatePricingIndexModal, UpdatePricingIndexModal } from '../../modals';
import usePricingIndices from '../../../hooks/api/usePricingIndices';

import * as styles from './PricingIndicesTab.css';

export default function PricingIndicesTab() {
  const { t } = useTranslation();

  const {
    pricingIndices,
    isLoading,
    isRefetching,
    deletingId,
    handleCreatePricingIndex,
    handleUpdatePricingIndex,
    handleDeletePricingIndex,
  } = usePricingIndices();

  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);
  const [selectedPricingIndex, setSelectedPricingIndex] = useState<PricingIndex | null>(null);

  return (
    <div className={styles.root}>
      <div className={styles.tableContainer}>
        <div className={styles.tableTitle}>
          <TradingText />
          <TradingButton
            label={t('settings.pricingIndicesTab.table.addButton')}
            handleClick={() => setIsOpenCreateModal(true)}
            startIcon={<AddIcon size={16} />}
            disabled={isLoading}
          />
        </div>
        <PricingIndicesTable
          columns={getPricingIndicesColumns({
            setSelectedPricingIndex,
            handleDeletePricingIndex,
            deletingId,
          })}
          data={pricingIndices}
          isLoading={isLoading || isRefetching}
        />
      </div>
      {isOpenCreateModal && (
        <CreatePricingIndexModal setIsOpen={setIsOpenCreateModal} handleCreatePricingIndex={handleCreatePricingIndex} />
      )}
      {selectedPricingIndex && (
        <UpdatePricingIndexModal
          selectedPricingIndex={selectedPricingIndex}
          setSelectedPricingIndex={setSelectedPricingIndex}
          handleUpdatePricingIndex={handleUpdatePricingIndex}
        />
      )}
    </div>
  );
}
